import { Download } from "lucide-react";
import { useState } from "react";
import { toastApiError } from "@/lib/errorMessages";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui";
import { downloadStorageUrl } from "@/lib/storageFetch";

interface ReceiptDownloadLinkProps {
  fileUrl: string;
}

export function ReceiptDownloadLink({ fileUrl }: ReceiptDownloadLinkProps) {
  const { t } = useTranslation("components");
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = () => {
    setIsLoading(true);
    void downloadStorageUrl(fileUrl, "receipt.jpg")
      .catch((err) =>
        toastApiError(err, "generic", t("receiptDownloadFailed")),
      )
      .finally(() => setIsLoading(false));
  };

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      className="shrink-0 text-surface-500 hover:text-surface-800"
      isLoading={isLoading}
      leftIcon={<Download className="h-4 w-4" />}
      aria-label={t("receiptDownload")}
      onClick={handleDownload}
    />
  );
}
